module.exports = __webpack_public_path__ + "./fonts/ubuntu.medium.ttf";